export default __webpack_public_path__ + "static/media/dialog-intent.6afbf096.svg";